import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ThemeEnum } from '@Enums';

    @Injectable({
        providedIn: 'root'
    })
export class ThemeService {
    private style: HTMLLinkElement;
    private cssFile: string;
    private themeCSSID = 'themeCSS';
    
    private renderer: Renderer2;
    
    private currentTheme: ThemeEnum;
    
    constructor(
      @Inject(DOCUMENT) private document: Document,
      private rendererFactory: RendererFactory2
    ) { 
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    isV2ThemeCurrent() {
        return this.currentTheme === ThemeEnum.InterviewV2;
    }

    setTheme(theme: ThemeEnum) {
        this.currentTheme = theme;
        console.log(this.currentTheme);
        this.cssFile = `${theme}.css`;
        this.removeExistingThemeStyle(this.themeCSSID);
      
        // Create a link element via Angular's renderer to avoid SSR troubles
        this.style = this.renderer.createElement('link') as HTMLLinkElement;
  
        // Set type of the link item and path to the css file
        this.renderer.setProperty(this.style, 'rel', 'stylesheet');
        this.renderer.setProperty(this.style, 'href', this.cssFile);
        this.renderer.setProperty(this.style, 'id', this.themeCSSID);
  
        // Add the style to the head section
        this.renderer.appendChild(this.document.head, this.style);
    }
  
    removeExistingThemeStyle(themeCSSID: string) {
        const themeIDHTMlElem = this.document.getElementById(themeCSSID);
        if (themeIDHTMlElem) {
            this.renderer.removeChild(this.document.head, themeIDHTMlElem);
        }
    }
}